import React, { useEffect, useState } from 'react';
import { ICodigoNcm, IRepasseParceiro, IVendaDireta } from '../../../../../../../../../../../interfaces/IBaseDeCalculo';
import NCMViewContainer from '../ncmViewContainer/ncmViewContainer';
import { ICodigoNcm as ICodigoNcmBaseCalculo } from '../../../../../../../../../../../interfaces/IBaseDeCalculo';
import styles from './ncmViewContainerList.module.scss';
import { useBackEndRequests } from '../../../../../../../../../lib/backEndRequests';
import { useQuery } from '@tanstack/react-query';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';
import { BrLoading } from '@govbr-ds/react-components';

interface INCMViewContainerListProps {
  idVendaDireta?: number;
  idRepasseParceiro?: number;
  refreshQuery: boolean;
  hideAction?: boolean;
  setRefreshQuery: React.Dispatch<React.SetStateAction<boolean>>;
  setEdicaoNCM?: React.Dispatch<React.SetStateAction<ICodigoNcmBaseCalculo | undefined>>;
  edicaoNCM?: ICodigoNcmBaseCalculo;
  setListaCodigosNCM?: React.Dispatch<React.SetStateAction<ICodigoNcmBaseCalculo[]>>;
}

const NCMViewContainerList: React.FC<INCMViewContainerListProps> = ({
  idVendaDireta,
  idRepasseParceiro,
  refreshQuery,
  setRefreshQuery,
  setEdicaoNCM,
  edicaoNCM,
  hideAction,
  setListaCodigosNCM,
}) => {
  const [codigosNCM, setCodigosNCM] = useState<ICodigoNcm[]>([]);
  const { getVendaDiretaById, getRepasseParceiroById } = useBackEndRequests();

  const {
    data: vendaDiretaData,
    isLoading: isVendaDiretaDataLoading,
    error: vendaDiretaDataError,
    refetch: refetchVendaDireta,
  } = useQuery<IVendaDireta, IErrorWithSentryId>({
    queryKey: ['vendaDiretaQuery', idVendaDireta],
    queryFn: () => {
      return getVendaDiretaById(idVendaDireta || 0);
    },
    staleTime: 0,

    enabled: !!idVendaDireta && refreshQuery,
  });

  const {
    data: repasseParceiroData,
    isLoading: isRepasseParceiroDataLoading,
    error: repasseParceiroDataError,
    refetch: refetchRepasseParceiro,
  } = useQuery<IRepasseParceiro, IErrorWithSentryId>({
    queryKey: ['repasseParceiroQuery', idRepasseParceiro],
    queryFn: () => getRepasseParceiroById(idRepasseParceiro || 0),
    enabled: !!idRepasseParceiro && refreshQuery,
  });

  useEffect(() => {
    if (setListaCodigosNCM) {
      setListaCodigosNCM(codigosNCM);
    }
  }, [codigosNCM, setListaCodigosNCM]);

  useEffect(() => {
    if (!idRepasseParceiro && !idVendaDireta) {
      setCodigosNCM([]);
    }
  }, [idRepasseParceiro, idVendaDireta]);

  useEffect(() => {
    if (vendaDiretaData) {
      setCodigosNCM(vendaDiretaData.codigosNCM);
      refetchVendaDireta();
    } else if (repasseParceiroData) {
      setCodigosNCM(repasseParceiroData.codigosNCM);
      refetchRepasseParceiro();
    }
    setRefreshQuery(false);
  }, [vendaDiretaData, repasseParceiroData, refreshQuery]);

  return (
    <div className={styles.container}>
      {isRepasseParceiroDataLoading || isVendaDiretaDataLoading ? (
        <BrLoading />
      ) : vendaDiretaDataError || repasseParceiroDataError ? (
        <div>Erro ao carregar dados</div>
      ) : (
        codigosNCM &&
        codigosNCM.length > 0 &&
        codigosNCM
          .filter((codigoNCM) => codigoNCM.id !== edicaoNCM?.id)
          .map((codigoNCM) => (
            <NCMViewContainer
              key={codigoNCM.id}
              codigoNCM={codigoNCM}
              setRefreshQuery={setRefreshQuery}
              hideAction={hideAction}
              setEdicaoNCM={setEdicaoNCM}
            />
          ))
      )}
    </div>
  );
};

export default NCMViewContainerList;
